/**
 * Site watermark for Highcharts charts.
 *
 * Call from a chart's `render` event so the watermark is redrawn on every
 * reflow/resize. Theme-aware via --bs-body-color (same approach as the
 * lightweight-charts watermark in chart_theme.js).
 *
 * @param {Object} chart - The Highcharts chart instance (`this` in a render handler)
 * @param {Function} position - (chart, bbox) => { x, y } for the text's
 *   left edge / baseline. Defaults to the centre of the plot area.
 */
export default function renderSiteWatermark(chart, position) {
  if (chart.siteWatermark) chart.siteWatermark.destroy()
  const color = getComputedStyle(document.documentElement)
    .getPropertyValue('--bs-body-color').trim() || '#212529'
  chart.siteWatermark = chart.renderer
    .text('relativestrength.com.au', 0, 0)
    .css({
      fontSize: '42px',
      fontWeight: '600',
      color: color,
      opacity: 0.12,
      pointerEvents: 'none'
    })
    .add()
  const box = chart.siteWatermark.getBBox()
  const { x, y } = position
    ? position(chart, box)
    : {
        x: chart.plotLeft + (chart.plotWidth - box.width) / 2,
        y: chart.plotTop + (chart.plotHeight + box.height / 2) / 2
      }
  chart.siteWatermark.attr({ x, y })
}
